import capitalize from 'lodash-es/capitalize';
import { RouteLocationNormalized } from 'vue-router';
import i18n from '@/plugins/i18n';

export function sendWhiteLableRouteChange(to: RouteLocationNormalized): void {
    const t = i18n.global.t;
    let title = '';
    if (to.meta && (to.meta.menu || to.meta.breadcrumb)) {
        if (to.meta.menu) {
            title = t('menu.' + to.meta.menu) + ' > ';
        }
        if (to.meta.breadcrumb) {
            title += t('menu.' + to.meta.breadcrumb);
        }
    } else {
        title = capitalize(String(to.name));
    }

    let message = JSON.stringify({
        type: 'routeChange',
        href: to.path.replace('/', ''),
        title: title,
    });

    console.log('Send msg to parent: ' + message);
    window.parent.postMessage(message, '*');
}
